import React from 'react';
export function Footer() {
  return <footer className="bg-[#05070a] py-6 border-t border-white/5" data-id="element-63">
      <div className="max-w-[980px] mx-auto px-4 text-center" data-id="element-64">
        <p className="text-gray-500 text-sm" data-id="element-65">
          Copyright 2025 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}